// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Session token counter (memo dev/80) — right side of the chat status
   strip. Same muted grammar as the status line; digits stay steady. */

.cq7u5tj_Mww8QHUdWf0b {
  flex: none;
  font-size: 11px;
  color: var(--curio-text-secondary, var(--curio-text-meta));
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.kTcjhzHZ_cNvAbRcIfbI {
  animation: Lzu6WDjqrtKGrsibJSqr 1.6s ease-in-out infinite;
}

@keyframes Lzu6WDjqrtKGrsibJSqr {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .kTcjhzHZ_cNvAbRcIfbI {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/AgentSessionTokenCounter.module.css"],"names":[],"mappings":"AAAA;sEACsE;;AAEtE;EACE,UAAU;EACV,eAAe;EACf,0DAA0D;EAC1D,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,yDAAsD;AACxD;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Session token counter (memo dev/80) — right side of the chat status\n   strip. Same muted grammar as the status line; digits stay steady. */\n\n.counter {\n  flex: none;\n  font-size: 11px;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.live {\n  animation: tokenCounterPulse 1.6s ease-in-out infinite;\n}\n\n@keyframes tokenCounterPulse {\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .live {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"counter": `cq7u5tj_Mww8QHUdWf0b`,
	"live": `kTcjhzHZ_cNvAbRcIfbI`,
	"tokenCounterPulse": `Lzu6WDjqrtKGrsibJSqr`
};
export default ___CSS_LOADER_EXPORT___;
